<script lang="ts">
  import SelectSearch from '@/widgets/SelectSearch.svelte';

  export let options;
  export let value;
</script>

<style lang="scss">
  .token-wrap {
    :global(ul) {
      margin-top: 20px;
      max-height: 340px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.16);
    }
    :global(li) {
      padding: 0 18px;
      &:hover {
        background: none !important;
      }
    }
    :global(.item) {
      border-radius: 8px;
      padding-right: 8px;
      padding-left: 8px;
      &:hover {
        background: #f4f7fe;
      }
    }
    :global(.search-icon) {
      top: 50%;
      width: 20px;
      height: 20px;
      transform: translateY(-50%);
    }
    :global(.search) {
      border: 0.5px solid var(--unnamed, rgba(29, 33, 41, 0.12));
      border-radius: 20px;
      padding: 8px 0 8px 28px;
      height: 36px;
      &::placeholder {
        color: rgba(29, 33, 41, 0.45);
      }
    }
  }
  .item {
    box-sizing: border-box;
    padding: 4px 0;
  }
</style>

<span class="token-wrap">
  <SelectSearch {options} {value} type="border" style="border-radius: 8px; height: 48px; line-height: 48px;" on:change>
    <div slot="displayItem">
      <slot name="displayItem" />
    </div>

    <div slot="item" let:option class="item mt12">
      <slot name="item" {option} />
    </div>
  </SelectSearch>
</span>
